(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sfb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Detect browser zoom level independent of window size or monitor.
    // outerWidth is the window's outer dimensions in CSS px and does NOT
    // change with browser zoom. innerWidth IS the zoomed viewport, so it
    // shrinks at zoom > 100% and grows at zoom < 100%. The ratio therefore
    // tracks zoom directly:
    //   100% zoom → ~1.00
    //   110% zoom → ~1.10
    //    90% zoom → ~0.90
    // Earlier version used innerWidth/screen.width — that mistreated users
    // whose browser window wasn't pixel-perfect fullscreen (a sub-screen
    // window has innerWidth < screen.width even at 100% zoom).
    function updateHeroZoomState() {
      if (!window.outerWidth || !window.innerWidth) return;
      var zoom = window.outerWidth / window.innerWidth;
      // Strip padding only when zoomed in past ~107% so 105% still shows
      // padding, but 110% reliably trips. Zoom-out (ratio < 1.0) never
      // trips this, so padding always returns on zoom-out.
      document.documentElement.classList.toggle('sfb-hero-no-pad', zoom > 1.07);
    }
    updateHeroZoomState();
    window.addEventListener('resize', updateHeroZoomState);

    function init(root) {
      if (!root || root.dataset.sfbHeroInit === '1') return;
      root.dataset.sfbHeroInit = '1';

      var inner = root.querySelector('.sfb-hero__inner');
      var track = root.querySelector('[data-sfb-hero-track]');
      if (!inner || !track) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sfb-hero-dots] .sfb-hero__bullet'));
      var prev = root.querySelector('[data-sfb-hero-prev]');
      var next = root.querySelector('[data-sfb-hero-next]');

      var originals = Array.prototype.slice.call(track.children);
      var total = originals.length;
      if (total < 2) return;

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplayEnabled = root.dataset.autoplay !== 'false' && !prefersReducedMotion;
      var speed = parseInt(root.dataset.autoplaySpeed, 10);
      if (!speed || speed < 3) speed = 6;
      speed = speed * 1000;

      // Clone first to end and last to start for seamless circular loop
      var firstClone = originals[0].cloneNode(true);
      var lastClone = originals[total - 1].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, originals[0]);

      var i = 1;
      var logical = 0;
      var animating = false;
      var timer = null;
      var wrapTimer = null;

      function setTransform(animate) {
        track.style.transition = animate ? 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
      }

      // Finish an animated move: clear the in-flight state and snap a clone
      // position back to its matching real slide (no animation).
      function settle() {
        clearTimeout(wrapTimer);
        wrapTimer = null;
        animating = false;
        wrapCloneIfNeeded();
      }

      // Timer-driven fallback for the clone reset. `transitionend` on the
      // track is unreliable here (observed not firing in dev), so without this
      // the reset is deferred to the next go()'s cancelInFlight, which then
      // animates BACKWARD off the clone — the "slides back to the beginning"
      // bug. 740ms clears the 700ms transform transition.
      function scheduleSettle() {
        clearTimeout(wrapTimer);
        wrapTimer = setTimeout(settle, 740);
      }

      function updateDots() {
        dots.forEach(function (d, k) {
          var active = k === logical;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      // Cancel any in-flight transition so the next click commits immediately.
      // Without this, dot + arrow clicks landing inside the 0.7s autoplay
      // transition window were silently swallowed by the `if (animating) return`
      // early-out, which read as "the buttons don't work."
      function cancelInFlight() {
        if (!animating) return;
        clearTimeout(wrapTimer);
        wrapTimer = null;
        track.style.transition = 'none';
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        animating = false;
        wrapCloneIfNeeded();
      }

      function go(dir) {
        cancelInFlight();
        animating = true;
        i += dir;
        logical = (logical + dir + total) % total;
        setTransform(true);
        updateDots();
        scheduleSettle();
      }

      function jumpTo(targetLogical) {
        cancelInFlight();
        if (targetLogical === logical) return;
        animating = true;
        var diff = (targetLogical - logical + total) % total;
        var back = total - diff;
        if (diff <= back) {
          i += diff;
        } else {
          i -= back;
        }
        logical = targetLogical;
        setTransform(true);
        updateDots();
        scheduleSettle();
      }

      function startAutoplay() {
        if (!autoplayEnabled) return;
        stopAutoplay();
        timer = setInterval(function () { go(1); }, speed);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Wrap clones back to the matching real slide. Called from
      // transitionend (normal flow) and from the swipe handler (when a
      // gesture interrupts a wrap-around transition mid-flight).
      function wrapCloneIfNeeded() {
        if (i === total + 1) {
          i = 1;
          setTransform(false);
        } else if (i === 0) {
          i = total;
          setTransform(false);
        }
      }

      track.addEventListener('transitionend', function (e) {
        if (e.propertyName && e.propertyName !== 'transform') return;
        settle();
      });

      if (prev) prev.addEventListener('click', function () { go(-1); startAutoplay(); });
      if (next) next.addEventListener('click', function () { go(1); startAutoplay(); });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { jumpTo(k); startAutoplay(); });
      });

      // Pointer-based swipe with live drag-follow.
      // Why pointer events over touchstart/move/end:
      //  1. Single API for touch/mouse/pen.
      //  2. setPointerCapture keeps the gesture alive if the finger leaves the
      //     track (e.g. drags onto the nav button or off-screen edge).
      //  3. Avoids an autoplay-race bug present in the prior touch impl: if a
      //     `setInterval` `go()` fired *during* a swipe, `animating=true` would
      //     silently swallow the user's `go()` at touchend. We now cancel any
      //     in-flight transition on drag start so the drag is immediate.
      //
      // touch-action: pan-y on .sfb-hero__track + .sfb-hero__slide already
      // tells the browser "you own vertical scroll, JS owns horizontal" — so
      // the browser won't claim the gesture before our handler sees it.
      var dragStartX = 0, dragStartY = 0, dragDx = 0;
      var dragStartedAt = 0;  // ms timestamp at pointerdown — drives the flick-velocity commit
      var dragActive = false; // a pointer is down
      var lock = null;        // null | 'h' (committed to swipe) | 'v' (yielded to scroll)
      var trackWidth = 0;

      function snapTo(targetI, animate) {
        // 0.28s with a quick-out curve so the slide settles fast after the
        // finger lifts — anything longer (0.35s+) reads as laggy on mobile.
        track.style.transition = animate ? 'transform 0.28s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
        track.style.transform = 'translateX(-' + (targetI * 100) + '%)';
      }

      function onPointerDown(e) {
        // Ignore right-click / middle-click / non-primary touches.
        if (e.pointerType === 'mouse' && e.button !== 0) return;

        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragStartedAt = Date.now();
        dragDx = 0;
        dragActive = true;
        lock = null;
        trackWidth = (inner.getBoundingClientRect().width) || 1;
        stopAutoplay();

        // Cancel any in-flight slide transition so the drag is immediate
        // and the user's gesture wins over autoplay. If we cancel during a
        // clone wrap (i = 0 or total+1), the transitionend cleanup never
        // fires, so we wrap manually here to keep i in range for the next go().
        if (animating) {
          clearTimeout(wrapTimer);
          wrapTimer = null;
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (i * 100) + '%)';
          animating = false;
          wrapCloneIfNeeded();
        }

        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (_) {}
        }
      }

      function onPointerMove(e) {
        if (!dragActive) return;
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;

        if (lock === null) {
          // Lock-to-horizontal is generous (>=5px) so the carousel claims the
          // gesture immediately as the finger starts moving sideways — the
          // single biggest source of "swipe feels stuck" reports on mobile.
          // Lock-to-vertical requires |dy| > 18 AND clearly dominate dx
          // (1.6× the horizontal motion) so a small downward drift during a
          // horizontal swipe doesn't kill the gesture.
          var adx = Math.abs(dx), ady = Math.abs(dy);
          if (adx >= 5 && adx >= ady) {
            lock = 'h';
          } else if (ady > 18 && ady > adx * 1.6) {
            lock = 'v';
            dragActive = false;
            return;
          } else {
            return; // ambiguous — wait for more motion
          }
        }
        if (lock !== 'h') return;

        dragDx = dx;
        // Live drag-follow — finger moves the slide in real time.
        track.style.transition = 'none';
        track.style.transform = 'translateX(calc(-' + (i * 100) + '% + ' + dx + 'px))';

        // Suppress the browser's text-selection / image-drag on mouse drags.
        // For touch, touch-action: pan-y already covers it.
        if (e.cancelable && e.pointerType === 'mouse') e.preventDefault();
      }

      // Track when a real horizontal swipe just happened so the subsequent
      // synthetic `click` (fired by the browser when the finger lifts over a
      // CTA inside the slide) doesn't navigate. Without this, a user who
      // swipes and releases anywhere over the "Shop Now" / "Treat Mom"
      // button accidentally leaves the home page.
      var swipeClickShieldUntil = 0;

      function endDrag(committed) {
        if (!dragActive && lock !== 'h') {
          lock = null;
          startAutoplay();
          return;
        }
        dragActive = false;
        var horizontal = lock === 'h';
        lock = null;

        // Commit threshold: 30 px floor, 10% of slide width otherwise.
        // Previously 40 / 15% which felt sticky on a 390 px viewport (~59 px
        // required) — "I swiped but nothing happened" symptom. Velocity-based
        // commit kicks in below the distance threshold so a quick flick
        // counts even when the finger barely traveled.
        var threshold = Math.max(30, trackWidth * 0.10);
        var movedEnough = Math.abs(dragDx) > 4;
        var elapsed = Date.now() - dragStartedAt;
        var velocity = elapsed > 0 ? Math.abs(dragDx) / elapsed : 0; // px / ms
        var fastFlick = velocity > 0.45 && Math.abs(dragDx) > 16;

        if (committed && horizontal && (Math.abs(dragDx) >= threshold || fastFlick)) {
          go(dragDx < 0 ? 1 : -1);
        } else if (horizontal) {
          // Snap back to current slide.
          snapTo(i, true);
        }
        // Arm the click shield if the finger actually traveled — covers both
        // committed swipes and short drags that snap back (user clearly intended
        // to swipe, not tap, so don't fire whatever CTA is under their finger).
        if (horizontal && movedEnough) {
          swipeClickShieldUntil = Date.now() + 350;
        }
        dragDx = 0;
        startAutoplay();
      }

      // Capture-phase click suppressor — runs before any CTA's own click
      // handler / navigation. Scoped to the carousel inner so we don't shield
      // clicks elsewhere on the page.
      inner.addEventListener('click', function (e) {
        if (Date.now() < swipeClickShieldUntil) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }, true);

      function onPointerUp() { endDrag(true); }
      function onPointerCancel() { endDrag(false); }

      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerUp);
      track.addEventListener('pointercancel', onPointerCancel);
      // If the pointer leaves without firing pointerup (rare on mobile but
      // happens with mouse drags off-window), treat as commit so the user's
      // intent isn't lost.
      track.addEventListener('pointerleave', function () {
        if (dragActive) endDrag(true);
      });

      // Pause autoplay when tab hidden / focused (keyboard users reading a
      // slide shouldn't race the 6s timer). Hover-pause intentionally
      // removed — desktop users park their cursor on the hero and the
      // rotation looked broken.
      inner.addEventListener('focusin', stopAutoplay);
      inner.addEventListener('focusout', function (e) {
        if (!inner.contains(e.relatedTarget)) startAutoplay();
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      setTransform(false);
      updateDots();
      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('[data-sfb-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-sfb-hero]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-journal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var nodes = document.querySelectorAll('.sfb-jrnl-reveal');
  if (!nodes.length) return;
  if (!('IntersectionObserver' in window)) {
    nodes.forEach(function (n) { n.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  nodes.forEach(function (n, i) {
    n.style.transitionDelay = (Math.min(i, 5) * 0.06) + 's';
    io.observe(n);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.sfb-media');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) {
        s.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
      });
      return;
    }

    sections.forEach(function (s) {
      var targets = s.querySelectorAll('.reveal');
      if (!targets.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0.1 });
      targets.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-product-reviews-bottom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.sfbRvbInit === '1') return;
      root.dataset.sfbRvbInit = '1';

      // Reveal-on-scroll
      var reveals = root.querySelectorAll('[data-reveal]');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-visible'); });
      }

      // Sort: reorder the server-rendered cards in place (reviews come from the
      // Judge.me metafield, not a live widget, so there's nothing to reload).
      var sortSelect = root.querySelector('[data-sfb-rvb-sort]');
      if (sortSelect) {
        var sortNum = function (el, attr) { return parseFloat(el.getAttribute(attr)) || 0; };
        sortSelect.addEventListener('change', function () {
          var mode = this.value;
          var host = root.querySelector('.jdgm-rev-widg__reviews');
          if (!host) return;
          var cards = Array.prototype.slice.call(host.querySelectorAll('.jdgm-rev'));
          cards.sort(function (a, b) {
            switch (mode) {
              case '-rating':   return sortNum(b, 'data-rating') - sortNum(a, 'data-rating');
              case 'rating':    return sortNum(a, 'data-rating') - sortNum(b, 'data-rating');
              case '-pictures': return (b.querySelector('.jdgm-rev__pic, .jdgm-rev__pic-img') ? 1 : 0) - (a.querySelector('.jdgm-rev__pic, .jdgm-rev__pic-img') ? 1 : 0);
              case '-created_at':
              default:          return sortNum(b, 'data-date') - sortNum(a, 'data-date');
            }
          });
          cards.forEach(function (c) { host.appendChild(c); });
        });
      }

      // Client-side filter state
      var state = { search: '', media: false, chip: '' };
      var searchInput = root.querySelector('[data-sfb-rvb-search]');
      var mediaToggle = root.querySelector('[data-sfb-rvb-media]');
      var chips = root.querySelectorAll('[data-sfb-rvb-chip]');
      var countEl = root.querySelector('[data-sfb-rvb-count]');
      var listHost = null;

      function getCards() {
        return root.querySelectorAll('.jdgm-rev');
      }
      function applyFilters() {
        var cards = getCards();
        if (!cards.length) {
          if (countEl) countEl.textContent = '';
          return;
        }
        var q = (state.search || state.chip || '').trim().toLowerCase();
        var visible = 0;
        cards.forEach(function (card) {
          var hide = false;
          if (q) {
            var titleEl = card.querySelector('.jdgm-rev__title');
            var bodyEl = card.querySelector('.jdgm-rev__body');
            var text = ((titleEl ? titleEl.textContent : '') + ' ' + (bodyEl ? bodyEl.textContent : '')).toLowerCase();
            if (text.indexOf(q) === -1) hide = true;
          }
          if (!hide && state.media) {
            if (!card.querySelector('.jdgm-rev__pic, .jdgm-rev__pic-img')) hide = true;
          }
          if (hide) {
            card.setAttribute('data-sfb-rvb-hidden', '1');
          } else {
            card.removeAttribute('data-sfb-rvb-hidden');
            visible++;
          }
        });
        if (countEl) {
          if (state.search || state.chip || state.media) {
            countEl.textContent = 'Showing ' + visible + ' of ' + cards.length + ' on this page';
          } else {
            countEl.textContent = '';
          }
        }
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          state.search = this.value || '';
          if (state.search && state.chip) {
            // typing breaks chip lock
            chips.forEach(function (c) { c.classList.remove('is-on'); });
            state.chip = '';
          }
          applyFilters();
        });
      }
      if (mediaToggle) {
        mediaToggle.addEventListener('click', function () {
          state.media = !state.media;
          this.setAttribute('aria-pressed', state.media ? 'true' : 'false');
          applyFilters();
        });
      }
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var label = chip.getAttribute('data-sfb-rvb-chip') || '';
          var alreadyOn = chip.classList.contains('is-on');
          chips.forEach(function (c) { c.classList.remove('is-on'); });
          if (alreadyOn) {
            state.chip = '';
          } else {
            chip.classList.add('is-on');
            state.chip = label;
          }
          if (searchInput) searchInput.value = state.chip;
          state.search = state.chip;
          applyFilters();
        });
      });

      // Tabs (Reviews / Q&A) — UI only; if Q&A is enabled, allow toggling visibility
      var tabs = root.querySelectorAll('[data-sfb-rvb-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-on'); });
          tab.classList.add('is-on');
        });
      });

      // Re-apply filters whenever Judge.me re-renders the list (pagination,
      // sort) — wait for the widget to mount, then observe its parent.
      function attachObserver() {
        listHost = root.querySelector('.jdgm-rev-widg__reviews') || root.querySelector('.jdgm-review-widget');
        if (!listHost || !('MutationObserver' in window)) return;
        var mo = new MutationObserver(function () { applyFilters(); });
        mo.observe(listHost, { childList: true, subtree: true });
        applyFilters();
      }
      // Judge.me may not have rendered yet — poll briefly
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (root.querySelector('.jdgm-rev-widg__reviews') || tries > 40) {
          clearInterval(poll);
          attachObserver();
        }
      }, 250);
    }

    function initAll() {
      document.querySelectorAll('[data-sfb-rvb]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-sfb-rvb]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.sfbRvInit === '1') return;
      root.dataset.sfbRvInit = '1';

      var reveals = root.querySelectorAll('[data-reveal]');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      } else { reveals.forEach(function (el) { el.classList.add('is-visible'); }); }

      var tabs = root.querySelectorAll('[data-sfb-rv-tab]');
      tabs.forEach(function (tab) { tab.addEventListener('click', function () { tabs.forEach(function (t) { t.classList.remove('is-on'); }); tab.classList.add('is-on'); }); });

      var cardHost = root.querySelector('[data-sfb-rv-cards]');
      if (cardHost) {
        var sortSelect = root.querySelector('[data-sfb-rv-sort]');
        var ratingFilter = root.querySelector('[data-sfb-rv-rating-filter]');
        var moreBtn = root.querySelector('[data-sfb-rv-more]');
        var shownEl = root.querySelector('[data-sfb-rv-shown]');
        var progressFill = root.querySelector('[data-sfb-rv-progress]');
        var allCards = function () { return Array.prototype.slice.call(cardHost.querySelectorAll('.sfb-rv-card')); };
        var loaded = allCards().length;
        var limit = parseInt(root.getAttribute('data-sfb-rv-initial') || '4', 10) || 4;
        var num = function (el, attr) { return parseFloat(el.getAttribute(attr)) || 0; };
        var matches = function (card) { var f = ratingFilter ? ratingFilter.value : 'all'; return f === 'all' || String(num(card, 'data-rating')) === f; };

        function render() {
          var cards = allCards();
          var visible = cards.filter(matches);
          var shown = 0;
          cards.forEach(function (card) {
            if (matches(card) && shown < limit) { card.removeAttribute('data-sfb-hidden'); shown++; }
            else { card.setAttribute('data-sfb-hidden', ''); }
          });
          if (shownEl) shownEl.textContent = shown;
          if (progressFill) progressFill.style.width = Math.min(100, Math.round(shown / Math.max(1, loaded) * 100)) + '%';
          if (moreBtn) moreBtn.hidden = visible.length <= shown;
        }
        function sortCards(mode) {
          var cards = allCards();
          cards.sort(function (a, b) {
            switch (mode) {
              case 'created_at': return num(a, 'data-date') - num(b, 'data-date');
              case '-rating': return num(b, 'data-rating') - num(a, 'data-rating');
              case 'rating': return num(a, 'data-rating') - num(b, 'data-rating');
              case '-pictures': return num(b, 'data-has-photos') - num(a, 'data-has-photos');
              default: return num(b, 'data-date') - num(a, 'data-date');
            }
          });
          cards.forEach(function (c) { cardHost.appendChild(c); });
        }
        if (sortSelect) sortSelect.addEventListener('change', function () { sortCards(this.value); render(); });
        if (ratingFilter) ratingFilter.addEventListener('change', function () { limit = parseInt(root.getAttribute('data-sfb-rv-initial') || '4', 10) || 4; render(); });
        if (moreBtn) moreBtn.addEventListener('click', function () { limit += 4; render(); });
        render();
      }

      // CTA opens the branded write-review modal (snippets/sfb-write-review-modal).
      var cta = root.parentNode ? root.parentNode.querySelector('.sfb-wr-cta [data-wr-open]') : null;
      if (cta) {
        cta.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('sfb:write-review:open'));
        });
      }
    }

    function initAll() { document.querySelectorAll('[data-sfb-rv]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-sfb-rv]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-ritual-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sfb-rscroll]');
    if (!root) return;

    // Mobile: the scroll-pin layout is disabled in CSS — the rAF loop and
    // scroll listener below would just burn frames translating an element
    // whose transform is overridden by `!important`. Bail out completely.
    const isMobileLayout = window.matchMedia('(max-width: 750px)').matches;
    if (isMobileLayout) return;

    const iframe = root.querySelector('.sfb-rscroll__iframe');
    const panelsTrack = root.querySelector('.sfb-rscroll__panels');
    const panelCount = parseInt(root.dataset.panelCount || '0', 10) || 1;

    // ============================================================
    // Scroll-pin track translation
    // ============================================================
    // The section is min-height: N × 100vh. Its child .sfb-rscroll__layout is
    // sticky, so as the user scrolls the section stays pinned. We translate
    // .sfb-rscroll__panels upward in lockstep with scroll progress so panel 2
    // slides into view where panel 1 was, etc.
    //
    // Lerp-smoothed for buttery motion (same trick as the old video scrub).
    let trackTarget = 0;     // 0..1 — where the user has scrolled to
    let trackCurrent = 0;    // 0..1 — where the track is now (eases toward target)
    let lastTranslate = 0;
    let trackRafRunning = false;
    let isOnScreen = false;
    const LERP = 0.22;

    function getScrollPx() {
      // How many pixels past the top of the section we are. 0 when section
      // top hits viewport top (sticky just engaged); grows as user scrolls.
      const rect = root.getBoundingClientRect();
      return Math.max(0, -rect.top);
    }

    function applyTrackTranslate() {
      if (!panelsTrack || panelCount <= 1) {
        trackRafRunning = false;
        return;
      }
      const delta = trackTarget - trackCurrent;
      if (Math.abs(delta) < 0.5) {
        trackCurrent = trackTarget;
      } else {
        trackCurrent += delta * LERP;
      }
      // 1px of scroll = 1px of translate, capped at (panels - 1) × viewport
      // height so the LAST panel sits where panel 1 was. Beyond that cap, the
      // track HOLDS while the section continues to be pinned (the extra 100vh
      // of section height) — gives the user a beat on the final panel before
      // the section unsticks.
      const vh = window.innerHeight;
      const maxTranslate = (panelCount - 1) * vh;
      const clamped = Math.max(0, Math.min(maxTranslate, trackCurrent));
      if (Math.abs(clamped - lastTranslate) > 0.5) {
        panelsTrack.style.transform = `translateY(${-clamped}px)`;
        lastTranslate = clamped;
      }
      if (isOnScreen) {
        requestAnimationFrame(applyTrackTranslate);
      } else {
        trackRafRunning = false;
      }
    }

    function onScroll() {
      trackTarget = getScrollPx();
    }

    const trackIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!isOnScreen) {
            window.addEventListener('scroll', onScroll, { passive: true });
            isOnScreen = true;
            onScroll();
            if (!trackRafRunning) {
              trackRafRunning = true;
              requestAnimationFrame(applyTrackTranslate);
            }
          }
        } else if (isOnScreen) {
          window.removeEventListener('scroll', onScroll);
          isOnScreen = false;
          // rAF loop will exit on its next tick because isOnScreen is false.
        }
      });
    }, { threshold: [0, 0.01] });
    trackIO.observe(root);

    if (!iframe) return;

    // Capability gates: skip the ~3MB Three.js iframe on mobile / reduced-motion /
    // save-data and let the static fallback image carry the section. Cheaper
    // for the user, kinder to data plans, respects accessibility prefs.
    const isMobile = window.matchMedia('(max-width: 750px)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;

    if (isMobile || reducedMotion || saveData) {
      // Strip the iframe out entirely so the GLB never loads
      root.classList.add('use-fallback');
      iframe.removeAttribute('src');
      return;
    }

    // Reveal the iframe once it's loaded (avoids flash of blank rectangle —
    // the static fallback image is visible until then).
    iframe.addEventListener('load', () => {
      root.classList.add('is-iframe-loaded');
    });

    // The iframe initially has its src attribute pre-set in Liquid. We mirror
    // it into a data-src and STRIP the src so the iframe doesn't actually load
    // until the section enters viewport. The ~3MB load only happens when the
    // user is about to see the section, then stays loaded forever after — we
    // do NOT tear down on scroll-out, because mounting/unmounting the iframe
    // resets the Three.js scene to a different pose each time, which reads
    // as random "glitches" when the user scrolls back to the section.
    const initialSrc = iframe.getAttribute('src');
    iframe.setAttribute('data-src', initialSrc);
    iframe.removeAttribute('src');

    const lazyLoadIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !iframe.getAttribute('src')) {
          iframe.setAttribute('src', iframe.getAttribute('data-src'));
          lazyLoadIO.unobserve(root); // one-shot — never reload again
        }
      });
    }, { rootMargin: '200px' }); // 200px buffer — start loading just before visible
    lazyLoadIO.observe(root);

    // ============================================================
    // Pause / resume the iframe's render loop when offscreen.
    // ============================================================
    // Cross-origin iframes keep their requestAnimationFrame loop running even
    // when scrolled out of view, so the Three.js scene burns GPU/CPU forever
    // after first load. We fix this by postMessage-ing pause/resume as the
    // section enters/leaves viewport (and on tab visibilitychange).
    //
    // The iframe (santafebotanicals.studio) MUST listen for these messages
    // and gate its render loop. Until that listener ships in the studio app
    // these messages are no-ops — costs nothing on the parent side.
    //   window.addEventListener('message', e => {
    //     if (e.data?.source !== 'sfb-rscroll') return;
    //     if (e.data.type === 'pause')  stopRenderLoop();
    //     if (e.data.type === 'resume') startRenderLoop();
    //   });
    let iframeOrigin = '*';
    try {
      iframeOrigin = new URL(initialSrc, window.location.href).origin;
    } catch (_) {}

    let lastMsg = null;
    function tellIframe(type) {
      if (lastMsg === type) return;
      if (!iframe.contentWindow) return;
      try {
        iframe.contentWindow.postMessage({ source: 'sfb-rscroll', type }, iframeOrigin);
        lastMsg = type;
      } catch (_) {}
    }

    const renderIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // 200px rootMargin so the scene resumes just before fully visible
        // and pauses only after fully offscreen — no scrub-stalling at the edges.
        tellIframe(entry.isIntersecting ? 'resume' : 'pause');
      });
    }, { rootMargin: '200px' });
    renderIO.observe(root);

    // Also pause when the tab is backgrounded — browsers throttle rAF in
    // background tabs but not aggressively for cross-origin iframes; this
    // makes the freeze immediate and explicit.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) tellIframe('pause');
      else if (root.getBoundingClientRect().top < window.innerHeight + 200) tellIframe('resume');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-spa-rituals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript && document.currentScript.closest('.sfb-spa-ritual');
    // currentScript not available inside theme {% javascript %} bundle — fallback to all
    var sections = section ? [section] : document.querySelectorAll('.sfb-spa-ritual');

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) {
        s.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
      });
      return;
    }

    sections.forEach(function (s) {
      var targets = s.querySelectorAll('.reveal');
      if (!targets.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0.1 });
      targets.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfb-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-sfb-testimonials]').forEach(function (root) {
      if (root.dataset.sfbTestimonialsInited === 'true') return;
      root.dataset.sfbTestimonialsInited = 'true';

      root.querySelectorAll('[data-column-track]').forEach(function (track) {
        if (track.children.length === 0) return;
        track.innerHTML = track.innerHTML + track.innerHTML;
      });

      var revealEls = root.querySelectorAll('.reveal');
      if ('IntersectionObserver' in window && revealEls.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      }

      var carousel = root.querySelector('[data-mobile-carousel]');
      var dots = root.querySelectorAll('[data-dots] .sfb-testimonials__dot');
      var swipeHint = root.querySelector('[data-swipe-hint]');
      var hasScrolled = false;

      if (carousel && dots.length) {
        carousel.addEventListener('scroll', function () {
          var cards = carousel.querySelectorAll('.testimonial-card');
          if (!cards.length) return;
          var cardWidth = cards[0].offsetWidth;
          var gap = 14;
          var idx = Math.min(
            Math.round(carousel.scrollLeft / (cardWidth + gap)),
            dots.length - 1
          );
          dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
          if (!hasScrolled && swipeHint) {
            hasScrolled = true;
            swipeHint.classList.add('is-hidden');
          }
        }, { passive: true });
      }

      var columns = root.querySelector('[data-columns]');
      if (columns) {
        columns.addEventListener('touchstart', function () {
          columns.querySelectorAll('[data-column-track]').forEach(function (t) {
            t.style.animationPlayState = 'paused';
          });
        }, { passive: true });

        columns.addEventListener('touchend', function () {
          setTimeout(function () {
            columns.querySelectorAll('[data-column-track]').forEach(function (t) {
              t.style.animationPlayState = 'running';
            });
          }, 2000);
        }, { passive: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
